<template>
  <app-date-picker
      ref="datepicker"
      :value="selected"
      :open="isOpen"
      :popup-class="popupClass"
      :type="inputType"
      :valueType="valueType"
      :range="range"
      :format="format"
      :input-attr="inputAttr"
      :clearable="clearable"
      :input-class="inputClass"
      :rangeSeparator="rangeSeparator"
      :disabled-date="disabledDate"
      :class="{
        'date-input-error':
          (field.overlap && field.overlap.hasError) ||
          (field.dayAfter && field.dayAfter.hasError)
      }"
      @pick="(e) => onCalenderPick(e)"
      @input="inputChange"
      @open="opening"
      @close="closing"
      :show-time-header="true"
      :disabled="disabled"
  >
    <template slot="icon-calendar" v-if="!!calendarButtonIcon">
      <span :class="calendarButtonIcon" aria-hidden="true"></span>
    </template>

    <template slot="sidebar" v-if="!!$scopedSlots.sidebar">
      <slot name="sidebar"></slot>
    </template>

    <template slot="footer" v-if="!!$scopedSlots.footer">
      <slot name="footer"></slot>
    </template>
  </app-date-picker>
</template>

<script>
  import moment from 'moment'
  import DatePicker from 'vue2-datepicker';

  export default {
    props: {
      value: {
        type: [String, Array, Date]
      },
      field: {
        type: Object,
        required: false,
        default: () => {
          return {};
        }
      },
      inputClass: {
        type: String,
        required: false
      },
      popupClass: {
        type: String,
        required: false
      },
      inputType: {
        type: String,
        default: 'date'
      },
      valueType: {
        type: String,
        required: false
      },
      range: {
        type: Boolean,
        default: false
      },
      format: {
        type: String,
        required: false
      },
      inputAttr: {
        type: Object,
        required: false
      },
      clearable: {
        type: Boolean,
        default: true
      },
      rangeSeparator: {
        type: String,
        required: false
      },
      onOpen: {
        type: Function,
        default: () => null
      },
      onCalenderPick: {
        type: Function,
        default: () => null
      },
      calendarButtonIcon: {
        type: String,
        required: false
      },
      maxDate: {
        type: Date,
        required: false,
        default: null
      },
      minDate: {
        type: [Date, String],
        required: false,
        default: null
      },
      useUtc: Boolean,
      disabled: {
        type: Boolean,
        default: () => false
      }
    },
    components: {
      'app-date-picker': DatePicker
    },
    data() {
      return  {
        isOpen: false,
        changedValue: null
      }
    },
    computed: {
      selected: {
        get () {
          if (this.useUtc) {
            const value = new Date(this.value)
            const offset = value.getTimezoneOffset();
            return new Date(value.getTime() + offset * 60 * 1000);
          } else {
            return this.value;
          }
        },
        set (val) {
          if (this.useUtc) {
            const offset = new Date().getTimezoneOffset();
            this.value = new Date(val.getTime() - offset * 60 * 1000)
          } else {
            this.value = val;
          }
        }
      }
    },
    methods: {
      inputChange(newValue) {
        if (this.useUtc) {
          newValue = new Date(newValue.getFullYear() + "-" + ("0" + (newValue.getMonth() + 1)).slice(-2) + "-" + (("0" + (newValue.getDate())).slice(-2)) + "T00:00:00Z");
        }
        this.changedValue = newValue;
        this.$emit('onInputChange', newValue);
      },
      opening() { 
        this.isOpen = true 
      },
      closing() {
        this.$emit('closing');
        this.isOpen = false;
      },
      parseBoundDate(value) {
        if (!value) {
          return null;
        }

        if (value instanceof Date && !Number.isNaN(value.getTime())) {
          return new Date(value.getFullYear(), value.getMonth(), value.getDate());
        }

        if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
          const [year, month, day] = value.slice(0, 10).split('-').map(Number);

          return new Date(year, month - 1, day);
        }

        return null;
      },
      disabledDate(date) {
        if (this.field.disabledDate) return this.field.disabledDate(date, this.selected);

        const min = this.parseBoundDate(this.minDate);

        if (min) {
          const day = new Date(date.getFullYear(), date.getMonth(), date.getDate());

          if (day < min) {
            return true;
          }
        }

        if (this.maxDate) return date > this.maxDate;
        return false;
      }

    },
  }
</script>

<style lang="scss">
  $default-color: #555;
  $primary-color: darken($carma-blue, 5%);

  @import "~vue2-datepicker/scss/index.scss";

  .mx-datepicker-main {
    .mx-datepicker-sidebar {
      width: auto;
      padding: 0;
    }

    .mx-datepicker-content {
      float: left;
      margin-left: 0;
    }
  }

  .date-input-error.mx-datepicker .mx-input-wrapper input  {
      border: 1px solid $red;
      background-color: $pale-pink;
  }
  
</style>